import React, { forwardRef } from 'react';
import { cn } from '@/lib/utils';
interface AppTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const AppTextarea = forwardRef<HTMLTextAreaElement, AppTextareaProps>(({
  label,
  error,
  helperText,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-70">
        {label && <label className="block text-sm font-medium text-white/60 mb-1.5" data-id="element-71">
            {label}
          </label>}
        <textarea className={cn('w-full bg-white/[0.04] border border-white/[0.08] rounded-xl text-white placeholder:text-white/30', 'px-4 py-3 text-sm resize-none', 'focus:outline-none focus:border-[#8eff01]/40 focus:bg-white/[0.06] transition-all duration-200', error && 'border-red-500/40 focus:border-red-500/60', disabled && 'opacity-50 cursor-not-allowed')} disabled={disabled} {...props} data-id="element-72" />
        {error && <p className="mt-1.5 text-sm text-red-400" data-id="element-73">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-white/35" data-id="element-74">{helperText}</p>}
      </div>;
});
AppTextarea.displayName = 'AppTextarea';